/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import type { PropsFromCaller as EnrollButtonProps } from 'bundles/coursera-plus-common/components/prePurchaseUpsell/PrePurchaseUpsellEnrollButton';
import PrePurchaseUpsellEnrollButton from 'bundles/coursera-plus-common/components/prePurchaseUpsell/PrePurchaseUpsellEnrollButton';
import { courseraPlusProductVariants } from 'bundles/coursera-plus-common/constants/CourseraPlusProductVariant';
import { useCourseraPlusEnrollment } from 'bundles/coursera-plus-common/utils/prePurchaseUpsellUtils';

export type PropsFromCaller = Omit<EnrollButtonProps, 'onCtaClick'> & {
  productItemId: string;
  courseId?: string;
  s12nId?: string;
  isMonthly?: boolean;
  annualProductItemId?: string;
  isPrePurchaseUpsellAllPlansShown?: boolean;
  ariaLabelText?: string;
};

const PrePurchaseUpsellCourseraPlusEnrollButton = ({
  productItemId = courseraPlusProductVariants.MONTHLY_WITH_FREE_TRIAL,
  courseId,
  s12nId,
  isMonthly = false,
  annualProductItemId,
  isPrePurchaseUpsellAllPlansShown = true,
  ...props
}: PropsFromCaller) => {
  const { enrollInCourseraPlusSubscription } = useCourseraPlusEnrollment({
    courseraPlusProductItemId: productItemId,
    additionalOptions: { courseId, s12nId, isSubscriptionOnly: Boolean(!courseId && !s12nId) },
    annualProductItemId,
    isMonthly,
    isPrePurchaseUpsellAllPlansShown,
  });

  return <PrePurchaseUpsellEnrollButton onCtaClick={enrollInCourseraPlusSubscription} {...props} />;
};

export default PrePurchaseUpsellCourseraPlusEnrollButton;
